// extracted by mini-css-extract-plugin
export default {"slide":"C06zg","card":"PHaGi","oneCard":"rlKRm","imgContainer":"BvsSk","img":"tzTVQ","textContainer":"CnO8n","name":"RGdn_","sticker":"fEeqT"};